<input type="file"
       #fileUpload
       (change)="onFileSelected($event)"
       style="display:none;">
<div class="file-upload">
  <img width="{{width}}"
       height="{{height}}"
       src="{{icon}}" />

  <button mat-mini-fab color="primary" class="upload-btn"
          (click)="fileUpload.click()">
    <mat-icon>attach_file</mat-icon>
  </button>
</div>
